<div class="login-container">

  <div class="login-card">

    <div class="logo">
    <img src="../assets/Walgreens_Logo.png" class="img-fluid" />                               
    </div>

    <h1>Sign In</h1>

    <p class="subtitle">
      Sign in to access Walgreens Immunization Voucher Program
    </p>
<form [formGroup]="loginForm" (ngSubmit)="nextClick()">
    <div class="form-group">

         <!-- Inline Validation -->

   <!-- Error Messages -->
<div class="error" *ngIf="(loginForm.get('userEmail')?.touched &&
             loginForm.get('userEmail')?.invalid) || error">

  <small *ngIf="loginForm.get('userEmail')?.errors?.['required']">
    Email is required
  </small>

  <small *ngIf="loginForm.get('userEmail')?.errors?.['email']">
    Please enter a valid email address
  </small>

  <small *ngIf="error">
    {{ error }}
  </small>

</div>

      <input
        type="email" required email #emailInput
        placeholder="Email address" 
        formControlName="userEmail" maxlength="250"  
        (keydown.enter)="nextClick(); $event.preventDefault()" 
        (input)="resetError()"  autocomplete="email"     
      />

    

    </div>

    <div class="create-account">
      <a [routerLink]="'/register'">No account? Create one</a>
    </div>

    <div class="button-group">
      <button class="button-primary" (click)="backClick()">
        Back
      </button>
      <button type="submit" class="button-primary" >
        Next
      </button>
    </div>
</form>
  </div>

</div>
